import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { hasPowerReceivingRole } from '../utils/role-polarity';

export const powerReceivingGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const roles = auth.user()?.selfRoles ?? [];
  if (hasPowerReceivingRole(roles)) {
    return true;
  }

  return router.parseUrl('/curated-matches');
};
